export default __webpack_public_path__ + "static/pragicts-automation-services-scripting-coding-9e3b83df944b9edd88a4408460bee33a.jpg";